<script setup lang="ts">
import { ref, watch } from 'vue';
import { SUPPORTED_LOCALES, currentLocale, setLocale } from '../i18n';

const model = ref(currentLocale());
watch(model, (v) => setLocale(v));
</script>

<template>
  <select v-model="model" class="lang-picker" :aria-label="$t('aria.language')">
    <option v-for="l in SUPPORTED_LOCALES" :key="l.code" :value="l.code">{{ l.name }}</option>
  </select>
</template>
